import { css } from "styled-components";

export const iconStyle = css`
  width: 20px;
  height: 20px;
`;
